module.exports = __webpack_public_path__ + "assets/img/m_bdt_img2.57a1b313.png";